import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GptSearchRequest } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/gpt/gpt.pb'
import { GptSearchResponse } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/gpt/gpt.pb'

export const gptSearch = (request: GptSearchRequest, options?: CashRequestOptions) =>
  post<GptSearchRequest, GptSearchResponse>('/2.0/cash/gpt-search', request, { ...options, rejectOnError: true })
